export default __webpack_public_path__ + "assets/821c799e4aa941a97be239ad6f359eec.svg";